Auth = require 'app/scripts/db/auth'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'

getOrganizationName = (org) ->
  if _.isString(org) then org else org.get('name')

module.exports =
  getSearchUrl: (query) ->
    "/search?q=#{ encodeURIComponent(query) }"

  getOrganizationName: getOrganizationName

  getOrganizationUrl: (org) ->
    "/#{ getOrganizationName(org) }"

  getEnterpriseAdminDashboardUrl: (enterpriseOrName, tab) ->
    name = if _.isString(enterpriseOrName)
        enterpriseOrName
      else
        enterpriseOrName.get('name')
    if tab?
      "/e/#{ name }/admin/#{ tab }"
    else
      "/e/#{ name }/admin"

  _orgUrl: (org, path, options = {}) ->
    query =
      if options.returnUrl
        query = '?returnUrl=' + encodeURIComponent(options.returnUrl)
      else
        ""

    "#{ @getOrganizationUrl(org) }#{ path }#{ query }"

  getOrganizationMemberCardsUrl: (org, username) -> @getMemberCardsUrl(username, getOrganizationName(org))
  getOrganizationAccountUrl: (org) -> @_orgUrl(org, '/account')
  getOrganizationBillingUrl: (org, options) -> @_orgUrl(org, '/billing', options)
  getOrganizationExportUrl: (org) -> @_orgUrl(org, '/export')
  getOrganizationMembersUrl: (org) -> @_orgUrl(org, '/members')
  getOrganizationReportsUrl: (org) -> @_orgUrl(org, '/reports')
  getOrganizationGuestUrl: (org) -> @_orgUrl(org, '/members/guests')
  getOrganizationPowerUpsUrl: (org) -> @_orgUrl(org, '/power-ups')

  getBoardUrl: (idBoard, section, extra = []) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    if idBoard?.id?
      idBoard = idBoard.id

    board = ModelCache.get('Board', idBoard)

    if (url = board?.get('url'))?
      baseUrl = Util.relativeUrl(url)

    else
      name = board?.get('name')

      baseUrl =
        if name
          "/board/#{Util.makeSlug(name)}/#{idBoard}"
        else
          "/board/#{idBoard}"

    if section
      baseUrl += "/#{ section }"

    for part in extra
      baseUrl += "/#{ part }"

    baseUrl

  getBoardShortUrl: (idBoard, section) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'

    if idBoard?.id?
      idBoard = idBoard.id

    board = ModelCache.get('Board', idBoard)

    if (shortUrl = board?.get('shortUrl'))?
      baseUrl = Util.relativeUrl(shortUrl)

    else
      shortLink = board?.get('shortLink')

      baseUrl = "/b/#{ shortLink }"

    if section
      baseUrl += "/#{ section }"

    baseUrl

  getBoardPowerUpsUrl: (board) ->
    @getBoardUrl(board) + '/power-ups'

  getUpgradeUrl: (board) ->
    if (org = board.getOrganization())?
      @getOrganizationBillingUrl(org)
    else
      '/business-class'

  getBoardPowerUpsUpgradeUrl: (board) ->
    if (org = board.getOrganization())?
      @getOrganizationBillingUrl(org, {
        returnUrl: @getBoardPowerUpsUrl(board)
      })
    else
      '/business-class'


  getMemberBoardProfileUrl: (username, idBoard) -> [@getBoardUrl(idBoard), 'member', username].join('/')
  getMemberProfileUrl: (username = Auth.myUsername()) -> "/#{username}"
  getMemberBoardsUrl: (username = Auth.myUsername(), orgname, showHomeBoardsTab, templatesData) ->
    if orgname
      return @getMemberOrgUrl(orgname, showHomeBoardsTab)
    else if showHomeBoardsTab
      return "/#{username}/boards"
    else if templatesData
      templatesUrl = "/templates"
      if templatesData.category
        templatesUrl += "/#{templatesData.category}"
      if templatesData.templateSlug
        templatesUrl += "/#{templatesData.templateSlug}"
    else
      return '/'
  getMemberOrgUrl: (orgname, showHomeBoardsTab) ->
    if showHomeBoardsTab
      return "/#{orgname}/home"
    else
      return "/#{orgname}/highlights"

  getMemberCardsUrl: (username = Auth.myUsername(), orgname) ->
    if orgname
      "/#{username}/cards/#{orgname}"
    else
      "/#{username}/cards"
  getMemberAccountUrl: (username = Auth.myUsername()) -> "/#{username}/account"
  getMemberBillingUrl: (username = Auth.myUsername()) -> "/#{username}/billing"
  getMemberActivityUrl: (username = Auth.myUsername()) -> "/#{username}/activity"

  getCardUrl: (card, highlight, replyToComment) ->
    baseUrl =
      if (url = card.get('url'))?
        Util.relativeUrl(url)
      else
        idBoard = card.get('idBoard')
        idCard = card.get('idShort') ? card.id
        card_name = card.get('name')

        if !idCard?
          null
        else if Util.isShortId(idCard)
          "/card/#{Util.makeSlug(card_name)}/#{idBoard}/#{idCard}"
        else
          "/card/board/#{Util.makeSlug(card_name)}/#{idBoard}/#{idCard}"

    if replyToComment
      [baseUrl, "replyToComment=#{replyToComment}"].join('?')
    else if highlight
      [baseUrl, highlight].join('#')
    else
      baseUrl

  getCardUrlWithoutModels: (idBoard, idCard, card_name) ->
    if !idCard?
      null
    else if Util.isShortId(idCard)
      "/card/#{Util.makeSlug(card_name)}/#{idBoard}/#{idCard}"
    else
      "/card/board/#{Util.makeSlug(card_name)}/#{idBoard}/#{idCard}"

  getBoardInvitationLinkUrl: (board, secret) ->
    "/invite/b/#{ board.get('shortLink') }/#{ secret }/#{ Util.makeSlug(board.get('name')) }"

  getOrganizationInvitationLinkUrl: (org, secret) ->
    "/invite/#{ org.get('name') }/#{ secret }"

  getActionUrl: (action) ->
    prefix =
      if action.isCommentLike()
        "comment"
      else
        "action"

    highlight = [prefix, action.id].join('-')

    card = action.getCard()
    if card
      @getCardUrl(card, highlight)
    else if (cardData = action.get('data').card)?
      # We don't have the card model.  This commonly happens if the card this
      # is an action for has been archived and wasn't loaded.
      ["/c/#{ cardData.shortLink }/", highlight].join('#')
    else
      null

